import type { ShareAuthCheckData, ShareOwnerData } from '../types';

export const ShareOwnerInfoApi = Symbol('ShareOwnerInfoApi');

export interface ShareOwnerInfoApi {
    getShareOwnerInfo(inData: ShareAuthCheckData): Promise<ShareOwnerData>
}
